function openTooltip() {
    $(".tooltip-icon").tooltip();
}

module.exports = {
    openTooltip: openTooltip
};
